import React from 'react';
import { useTranslation } from 'react-i18next';

const PricingSimulationHeader = ({ onSaveDraft, isSaving, onSendForApproval }) => {
    const { t } = useTranslation();

    return (
        <div className="price-simulation-header">
            <div className="price-simulation-header-left">
                <h2 className="price-simulation-title">{t('priceSimulation.pageTitle')}</h2>
                <p className="price-simulation-subtitle">{t('priceSimulation.subtitle')}</p>
            </div>
            <div className="price-simulation-header-right">
                {/* TODO - Re-Implement together with Revenue data! */}
                {/* <div className="period-toggle">
                    <div className="period-toggle-buttons" title='Not yet implemented! Wait for revenue!'>
                        <button
                            className={`disabled period-toggle-btn${periodMonths === 1 ? ' active' : ''}`}
                            onClick={() => onPeriodToggle(1)}
                            disabled
                        >
                            <span className="vismaicon vismaicon-sm vismaicon-calendar period-toggle-icon"></span>
                            <span style={{ verticalAlign: 'middle' }}>1M</span>
                        </button>
                        <button
                            className={`disabled period-toggle-btn${periodMonths === 12 ? ' active' : ''}`}
                            onClick={() => onPeriodToggle(12)}
                            disabled
                        >
                            12M
                        </button>
                    </div>
                </div>

                <div className="header-divider"></div> */}
                
                <div className="header-actions">
                    {/* TODO - Re-Implement together with respective function flows! */}
                    {/* <button className="header-action-btn" onClick={onBulkAdjustment}>
                        <span className="vismaicon vismaicon-sm vismaicon-edit"></span>
                        {t('priceSimulation.bulkAdjustment')}
                    </button>

                    <button className="header-action-btn" onClick={onExportChanges}>
                        <span className="vismaicon vismaicon-sm vismaicon-download"></span>
                        {t('priceSimulation.exportChanges')}
                    </button> */}

                    <button className="header-action-btn" onClick={onSaveDraft} disabled={isSaving}>
                        {t('priceSimulation.saveAsDraft')}
                    </button>

                    <button className="header-primary-btn" onClick={onSendForApproval}>
                        {t('priceSimulation.sendForApproval')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PricingSimulationHeader;
